// API Configuration for V2 - Updated for Vite
const API_CONFIG = {
    // Strapi CMS endpoints
    STRAPI_BASE_URL: import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337',
    STRAPI_API_URL: `${import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337'}/api`,

    // Express API endpoints  
    EXPRESS_BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
    EXPRESS_API_URL: `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api`,

    // Upload configuration
    UPLOAD_URL: import.meta.env.VITE_UPLOAD_URL || 'http://localhost:1337',
    MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB
    ALLOWED_TYPES: ['exterior', 'interior', 'models', 'animations', 'hdr', 'panoramic360', 'products'],
};

// Strapi endpoints
export const getStrapiUrl = (endpoint: string): string => {
    return `${API_CONFIG.STRAPI_API_URL}/${endpoint}`;
};

// Express API endpoints  
export const getApiUrl = (endpoint: string): string => {
    return `${API_CONFIG.EXPRESS_API_URL}/${endpoint}`;
};

export const getUploadUrl = (path?: string): string => {
    if (!path) return API_CONFIG.UPLOAD_URL;

    // Remove leading slash from path if it exists to avoid double slashes
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return `${API_CONFIG.UPLOAD_URL}/${cleanPath}`;
};

// Specific API endpoints
export const ENDPOINTS = {
    // Strapi CMS endpoints (updated to use products)
    PRODUCTS: 'products',
    PRODUCT_CHILDREN: 'product-children',
    SLIDESHOW_ITEMS: 'slideshows',
    SLIDESHOW_SETTINGS: 'slideshow-option',
    UPLOAD: 'upload',
    SECTIONS: 'sections',
    CHILD_SLIDES: 'child-slides',

    // Express API endpoints (for custom logic)
    GALLERY_MIGRATE: 'gallery/migrate',
    GALLERY_REORDER: 'gallery/reorder',
    SEARCH: 'search',
    ANALYTICS: 'analytics',
    EMAIL_CONTACT: 'email/contact',
    EMAIL_QUOTE: 'email/quote',

    // Strapi endpoints for help sections
    HELP_SECTIONS: 'help-sections',

    // Strapi endpoints for social and footer
    SOCIAL_BUTTONS: 'social-buttons',
    FOOTER_CONTENT: 'footer-content',

    // Strapi endpoint for popup settings
    POPUP_SETTINGS: 'popup-setting',
};

export default API_CONFIG;